import React, { useEffect, useRef } from 'react';
import { BlogFigure } from '../../BlogFigure';
import type { BlogEmbedId, KetteiEmbedId } from '../../types';
import figures from './figures.json';
import { mountKetteiFigure } from './renderFigures';
import './kettei.css';

export function isKetteiEmbed(name: BlogEmbedId): name is KetteiEmbedId {
  return Object.prototype.hasOwnProperty.call(figures, name);
}

export function KetteiFigure({ name }: { name: KetteiEmbedId }) {
  const root = useRef<HTMLDivElement>(null);
  const frame = useRef<HTMLDivElement>(null);
  const figure = figures[name];
  const number = 'figureNumber' in figure ? figure.figureNumber : undefined;

  useEffect(() => {
    if (!root.current || !frame.current) return;
    // The authored markup is static local content. Recreate only this figure's
    // DOM for each mount, including React StrictMode's setup/cleanup replay.
    const container = frame.current;
    container.innerHTML = figure.markup;
    const cleanup = mountKetteiFigure(root.current, name);
    return () => {
      cleanup();
      container.replaceChildren();
    };
  }, [name, figure]);

  return (
    <div ref={root} className={`kettei-figure ${name} font-body`}>
      <BlogFigure
        id={number ? `figure-${number}` : 'kettei-family-table'}
        figureNumber={number}
        frameClassName="p-3 sm:p-4"
        caption={
          <>
            {!number && <strong className="font-semibold text-foreground">Table 1. </strong>}
            <span dangerouslySetInnerHTML={{ __html: figure.captionHtml }} />
          </>
        }
      >
        <div ref={frame} />
      </BlogFigure>
    </div>
  );
}
